import { FC } from 'react';
import { Box } from '@mui/material';

import { JobFilterModalButton, JobSearchKeywordInput, JobSearchLocationInput } from '@carcareers/components';
import { SearchProvider } from '@carcareers/contexts';

export const JobseekerSearchBar: FC = () => {
  return (
    <SearchProvider>
      <Box sx={{ flex: 1, display: 'flex', gap: 2, mx: 4 }}>
        <JobSearchKeywordInput />
        <JobSearchLocationInput />
        <JobFilterModalButton />
      </Box>
    </SearchProvider>
  );
};

export default JobseekerSearchBar;
